import React, { useRef, useEffect } from "react";

const CaptchaCanvas = ({ text }) => {
  const canvasRef = useRef();

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");


    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.fillStyle = "#f3f3f3";
    ctx.fillRect(0, 0, canvas.width, canvas.height);


    ctx.font = "28px sans-serif";
    ctx.fillStyle = "#000";


    for (let i = 0; i < text.length; i++) {
      const char = text[i];
      const x = 20 + i * 20;
      const y = 30 + Math.random() * 5;
      const angle = Math.random() * 0.4 - 0.2;

      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.fillText(char, 0, 0);
      ctx.restore();
    }


    for (let i = 0; i < 5; i++) {
      ctx.strokeStyle = `rgba(0,0,0,${Math.random()})`;
      ctx.beginPath();
      ctx.moveTo(Math.random() * 100, Math.random() * 40);
      ctx.lineTo(Math.random() * 100, Math.random() * 40);
      ctx.stroke();
    }
  }, [text]);

  return <canvas ref={canvasRef} width={150} height={50} style={{ border: "1px solid #ccc" }} />;
};

export default CaptchaCanvas;
